import {
  RFC_GENERICO,
  NOBRE_GENERICO,
  USO_CFDI_GENERICO,
  METODO_PAGO,
  MONEDA,
  CONFIG_PLANTILLA_ID,
  LEYENDA_FOLIO,
  TIPO_COMPROBANTE,
  REGIMEN_FISCAL,
  METODO_PAGO_EFECTIVO,
  METODO_PAGO_TRANSF,
  METODO_PAGO_TCREDITO,
  METODO_PAGO_TDEBITO,
  METODO_PAGO_POR_DEFINIR,
} from "../_constants/receiptInfo";
import {
  getBrandAndModel,
  getProductPriceWithoutIVA,
  getIVAProduct,
  fixedNumberValue,
  getProductPriceInTicketReport,
  getProductDiscountInTicketReport,
} from "./utils";

export const buildJsonReceipt = (
  productsArray,
  receiptFormData,
  isGlobalFacture,
  siteInfo
) => {
  const Receptor = {};
  console.log("siteInfo", siteInfo);
  console.log("receiptFormData,", receiptFormData);
  if (isGlobalFacture) {
    Receptor.Rfc = RFC_GENERICO;
    Receptor.Nombre = NOBRE_GENERICO;
    Receptor.UsoCFDI = USO_CFDI_GENERICO; // jalar de form
  } else {
    const {
      colonia,
      cp,
      estado,
      exteriorNumber,
      interiorNumber,
      municipio,
      name,
      rfc,
      street,
      usoCfdi,
    } = receiptFormData;

    Receptor.Rfc = rfc;
    Receptor.Nombre = name;
    Receptor.UsoCFDI = usoCfdi;
    Receptor.Calle = street;
    Receptor.NoExt = exteriorNumber;
    Receptor.NoInt = interiorNumber;
    Receptor.Colonia = colonia;
    Receptor.Pais = "México";
    Receptor.CodigoPostal = cp;
    Receptor.Municipio = municipio;
    // CODIGO DE ESTADO ????
    Receptor.Estado = estado;
  }

  const conceptsArray = generateConceptArray(productsArray);
  const totalForReceipt = (
    getSubtotal(conceptsArray) +
    // - getTotalDiscount(conceptsArray) +
    getTotalTaxes(conceptsArray)
  ).toFixed(2);
  // console.log("TOTAL taxes", fixedNumberValue(getTotalTaxes(conceptsArray)));
  // console.log("SUBTOTAL", getSubtotal(conceptsArray));
  // console.log("TOTAL fixed", totalForReceipt);

  const bodyReceipt = {
    Fecha: "AUTO",
    config_plantilla_id: CONFIG_PLANTILLA_ID,
    Serie: siteInfo.serie,
    Folio: siteInfo.folio,
    MetodoPago: METODO_PAGO,
    SubTotal: getSubtotal(conceptsArray).toFixed(2),
    // Descuento: getTotalDiscount(conceptsArray).toString(),
    Total: totalForReceipt,
    Moneda: MONEDA,
    /* fijo cuando la moneda sea MXN */
    TipoCambio: 1,
    TipoDeComprobante: TIPO_COMPROBANTE,
    FormaPago: recoverPaymentMethod(productsArray),

    LugarExpedicion: siteInfo.cp,
    LeyendaFolio: LEYENDA_FOLIO,
    Emisor: {
      RegimenFiscal: REGIMEN_FISCAL,
    },
    Receptor,
    Conceptos: conceptsArray,
    Impuestos: {
      TotalImpuestosTrasladados: fixedNumberValue(getTotalTaxes(conceptsArray)),
      // TotalImpuestosRetenidos: null,
      Traslados: [
        {
          Impuesto: "002",
          TipoFactor: "Tasa",
          TasaOCuota: "0.160000",
          Importe: fixedNumberValue(getTotalTaxes(conceptsArray)),
        },
      ],
    },
  };
  return bodyReceipt;
};

const recoverPaymentMethod = (productsArray) => {
  /**
   * Si se seleccionaron varios metodos de pago
   * return METODO_PAGO_POR_DEFINIR
   */
  const paymentMethodArray = productsArray.map((item) => item.paymentMethodId);
  const paymentMethodEqual = paymentMethodArray.every(
    (v) => v === paymentMethodArray[0]
  );
  if (paymentMethodEqual) {
    switch (paymentMethodArray[0]) {
      case 1:
        return METODO_PAGO_EFECTIVO;
      case 2:
        return METODO_PAGO_TDEBITO;
      case 3:
        return METODO_PAGO_TCREDITO;
      case 4:
        return METODO_PAGO_TRANSF;
      default:
        return METODO_PAGO_POR_DEFINIR;
    }
  } else {
    return METODO_PAGO_POR_DEFINIR;
  }
};

const generateConceptArray = (productsArray) => {
  const bodyArray = [];

  productsArray.forEach((item) => {
    const {
      product: { productTypeId },
    } = item;
    const concept = {};
    // console.log(
    //   "CLAVE",
    //   retrieveProductServiceCode(productTypeId, item.product)
    // );
    concept.ClaveProdServ = retrieveProductServiceCode(
      productTypeId,
      item.product
    );
    concept.NoIdentificacion = item.id;
    concept.Cantidad = 1;
    concept.ClaveUnidad = retrieveClaveUnidad(productTypeId);
    concept.Unidad = retrieveUnidad(productTypeId);
    concept.Descripcion = getBrandAndModel(item, true);

    const subtotalProduct = getProductPriceInTicketReport(item.product);
    const discountProduct = getProductDiscountInTicketReport(item.product);
    const importeTotal = subtotalProduct - discountProduct;
    concept.ValorUnitario = fixedNumberValue(
      getProductPriceWithoutIVA(importeTotal)
    );
    concept.Importe = fixedNumberValue(getProductPriceWithoutIVA(importeTotal));
    // concept.Descuento = getProductDiscount(item);
    concept.Impuestos = {
      Traslados: [
        {
          Base: concept.Importe,
          // Catalogo_impuestos_cfdi
          Impuesto: "002",
          TipoFactor: "Tasa",
          TasaOCuota: "0.160000",
          Importe: fixedNumberValue(getIVAProduct(concept.Importe)),
        },
      ],
    };

    bodyArray.push(concept);
  });

  return bodyArray;
};

const retrieveProductServiceCode = (productId, productObject) => {
  /**
   * 1 - Equipo movil
   * 2 - Accesorios
   * 3 - Chips
   * 4 - Tarjetas saldo
   * 5 - Trasp saldo
   * 6 - Plan tarifario
   */
  switch (productId) {
    case 1:
      return productObject.movile?.provider?.providerCode || "43191501";
    case 2 || 3:
      return productObject.accesory?.provider?.providerCode || "43222900";
    case 4:
      return "83111504";
    case 5:
      return "80141628";
    // PENDIENTE Plan tarifario
    default:
      return "43191501";
  }
};

const retrieveClaveUnidad = (typeProduct) => {
  switch (typeProduct) {
    case 1 || 2 || 3 || 4:
      return "H87";
    case 5:
      return "E48";
    // PENDIENTE Plan tarifario
    default:
      return "H87";
  }
};

const retrieveUnidad = (typeProduct) => {
  switch (typeProduct) {
    case 1 || 2 || 3 || 4:
      return "Pieza";
    case 5:
      return "Servicio";
    // PENDIENTE Plan tarifario
    default:
      return "Pieza";
  }
};

const getTotalTaxes = (bodyReceiptArray) => {
  const totalTaxes = bodyReceiptArray.reduce((acc, item) => {
    return acc + parseFloat(item.Impuestos.Traslados[0].Importe, 10);
  }, 0);
  return totalTaxes;
};

const getSubtotal = (bodyReceiptArray) => {
  const subTotal = bodyReceiptArray.reduce((acc, item) => {
    return acc + parseFloat(item.Importe, 10);
  }, 0);
  return subTotal;
};

// const getTotalDiscount = (bodyReceiptArray) => {
//   const totalDiscout = bodyReceiptArray.reduce((acc, item) => {
//     return acc + parseFloat(item.Descuento, 10);
//   }, 0);
//   return totalDiscout;
// };

/**
 * "EstatusCobranza" = 0 Por cobrar,
 * 1 Cobrado Parcialmente,
 * 2 Cobrado totalmente
 *
 *
 * "MontoCobrado" = aqui ponemos monto total
 *
 * "SaldoInsoluto" = siempre poner 0,
 *  porque ya no hay saldo pendiente x cobrar
 */
